import React from "react"
import { P } from "@infotech/uikit-text"
import styles from "./styles.css"

const InternalServerErrorPage = ({ errorText }) => (
  <div className={styles.Container}>
    <div>
      <P className={styles.NotFoundCaption}>500</P>
    </div>
    <div>
      <P className={styles.InfoBold}>Ошибка</P>
    </div>
    <div>
      <P className={styles.Info}>{errorText}</P>
    </div>
  </div>
)

export default InternalServerErrorPage
